import { render, staticRenderFns } from "./ft.vue?vue&type=template&id=6b2b1542&scoped=true"
import script from "./ft.vue?vue&type=script&lang=js"
export * from "./ft.vue?vue&type=script&lang=js"
import style0 from "./ft.vue?vue&type=style&index=0&id=6b2b1542&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2b1542",
  null
  
)

export default component.exports